import React from 'react'
import Ripple from '@/components/Ripple'

export interface NoCardProps {
  /** 卡片类型：virtual-虚拟卡, physical-实体卡 */
  type?: 'virtual' | 'physical'
  /** 主标题文本 */
  title?: string
  /** 副标题文本 */
  subtitle?: string
  /** 添加按钮文本 */
  buttonText?: string
  /** 点击添加按钮回调 */
  onAdd?: () => void
  /** 自定义类名 */
  className?: string
}

const NoCard: React.FC<NoCardProps> = ({
  title = '您当前还没有可用卡片',
  subtitle = '可在下方快速添加',
  buttonText = '申请卡片',
  onAdd,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center px-4 py-16 ${className}`}>
      {/* 卡片图标 */}
      <div className="relative mb-8">
        {/* 卡片 SVG 图标 */}
        <img src="/images/card-v2/no-card.svg" alt="no-card" className="w-full h-full" />
      </div>

      {/* 文本内容 */}
      <div className="text-center space-y-2 mb-8">
        <div className="text-black text-base font-medium">{title}</div>
        <div className="text-[#667085] text-sm">{subtitle}</div>
      </div>

      {/* 添加按钮 */}
      <Ripple className="w-full rounded-xl">
        <div
          onClick={onAdd}
          className="w-full h-14 border-2 border-dashed border-gray-200 rounded-xl
                   bg-[#F4F6F9] flex items-center justify-center gap-2
                   text-black text-base font-medium"
        >
          <img src="/images/card-v2/add-circle.svg" alt="add-circle" className="w-5 h-5" />
          {buttonText}
        </div>
      </Ripple>
    </div>
  )
}

export default NoCard
